<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap class="mb-3">
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <message :messages="messages"></message>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-if="renderFire">
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <div>
              <h3 class="headline mb-0">{{labels.fireRisk}}</h3>
            </div>
          </v-card-title>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-checkbox v-model="packageForm.fireRisk.riskAdd" :label="labels.riskAdd" data-vv-name="riskAdd" :data-vv-as="labels.riskAdd" :error-messages="errors.collect('riskAdd')" @change="doRiskAdd" hide-details></v-checkbox>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="packageForm.fireRisk.riskAdd3" :label="labels.riskAdd3" :error-messages="errors.collect('riskAdd3')" data-vv-name="riskAdd3" :data-vv-as="labels.riskAdd3" prefix="#" v-validate="'unit_no|max:30'" :readonly="packageForm.fireRisk.riskAdd"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="packageForm.fireRisk.riskPostalCode" :label="labels.riskPostalCode" v-int-mask="{intScale: 6}" type="tel" :error-messages="errors.collect('riskPostalCode')" data-vv-name="riskPostalCode" :readonly="packageForm.fireRisk.riskAdd" :data-vv-as="labels.riskPostalCode" v-validate="'required|numeric'" :loading="riskPostalCodeLoading" @change="doRiskAddress"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="packageForm.fireRisk.riskAdd1" :label="labels.riskAdd1" :error-messages="errors.collect('riskAdd1')" data-vv-name="riskAdd1" :data-vv-as="labels.riskAdd1" v-validate="'required|entry|max:30'" :readonly="packageForm.fireRisk.riskAdd"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="packageForm.fireRisk.riskAdd2" :label="labels.riskAdd2" :error-messages="errors.collect('riskAdd2')" data-vv-name="riskAdd2" :data-vv-as="labels.riskAdd2" v-validate="'required|entry|max:255'" :readonly="packageForm.fireRisk.riskAdd"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="packageForm.fireRisk.riskAdd4" :label="labels.riskAdd4" :error-messages="errors.collect('riskAdd4')" data-vv-name="riskAdd4" :data-vv-as="labels.riskAdd4" v-validate="'entry|max:255'" :readonly="packageForm.fireRisk.riskAdd"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap class="mt-3">
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn round color="primary" type="submit" @click.prevent="doProceed">
        Next
        <v-icon right dark>mdi-chevron-right</v-icon>
      </v-btn>
    </v-layout>
  </v-container>
</template>

<script>
import { AGENCY_QUOTATION_LIFECYCLE, QUOTE_PACKAGE_FIRE_RISK } from '@/store/types'
import MessageMixin from '@/mixins/message'
import { SaveQuoteMixin } from '../../shared/saveQuoteMixin'
import { expandURI } from '@/utils/ajax'

// Current supported AppID
const supportedAppID = ['FI', 'MI']

export default {
  data() {
    return {
      labels: {
        fireRisk: 'Fire Risk',
        riskAdd: 'Same as Applicant Address',
        riskAdd1: 'Block/House No.*',
        riskAdd2: 'Street Name*',
        riskAdd3: 'Unit No.',
        riskAdd4: 'Building Name',
        riskPostalCode: 'Postal Code*'
      },
      packageForm: {
        fireRisk: {
          riskAdd: undefined,
          riskAdd1: undefined,
          riskAdd2: undefined,
          riskAdd3: undefined,
          riskAdd4: undefined,
          riskPostalCode: undefined
        }
      },
      riskPostalCodeLoading: false
    }
  },
  computed: {
    fireForm() {
      return this.$store.state.agency.quotation.fireForm
    },
    commonForm() {
      return this.$store.state.agency.quotation.commonForm
    },
    renderFire() {
      const selectedPlan = this.$store.getters.packageQuoteSelectedPlan
      if (selectedPlan && selectedPlan.appIDs && selectedPlan.appIDs.length > 0) {
        if (selectedPlan.appIDs.find(x => x === 'FI')) {
          return true
        }
      }
      return false
    }
  },
  methods: {
    doInit() {
      // Default value from vuex store 1st
      this.packageForm.fireRisk.riskAdd = this.fireForm.riskAdd
      this.packageForm.fireRisk.riskAdd1 = this.fireForm.riskAdd1
      this.packageForm.fireRisk.riskAdd2 = this.fireForm.riskAdd2
      this.packageForm.fireRisk.riskAdd3 = this.fireForm.riskAdd3
      this.packageForm.fireRisk.riskAdd4 = this.fireForm.riskAdd4
      this.packageForm.fireRisk.riskPostalCode = this.fireForm.riskPostalCode
    },
    async doRiskAddress() {
      const apiUrl = this.$store.state.agency.quotation.menu.address
      if (apiUrl) {
        try {
          this.riskPostalCodeLoading = true
          const expand = {
            postCode: this.packageForm.fireRisk.riskPostalCode
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result
          if (data) {
            this.packageForm.fireRisk.riskAdd1 = data.add1
            this.packageForm.fireRisk.riskAdd2 = data.add2
            this.packageForm.fireRisk.riskAdd4 = data.add4
          }
          this.riskPostalCodeLoading = false
        } catch (err) {
          this.riskPostalCodeLoading = false
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doRiskAdd() {
      this.packageForm.fireRisk.riskAdd1 = this.commonForm.applicant.appAdd1
      this.packageForm.fireRisk.riskAdd2 = this.commonForm.applicant.appAdd2
      this.packageForm.fireRisk.riskAdd3 = this.commonForm.applicant.appAdd3
      this.packageForm.fireRisk.riskAdd4 = this.commonForm.applicant.appAdd4
      this.packageForm.fireRisk.riskPostalCode = this.commonForm.applicant.appPostalCode
    },
    doBack() {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 3)
      this.$router.push({ name: 'packageQuoteApplicant' })
    },
    doProceed() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$store.commit(QUOTE_PACKAGE_FIRE_RISK, this.packageForm.fireRisk)
          this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 5)
          this.$router.push({ name: 'packageQuotePremium' })
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doPartialSave() {
      // No mandatory validation here. Commit whatever thats on screen and do neccesary actions before saving
      // Must return true/false
      try {
        if (this.renderFire) {
          this.$store.commit(QUOTE_PACKAGE_FIRE_RISK, this.packageForm.fireRisk)
        }
        await this.$store.dispatch('saveQuote')
        return true
      } catch (err) {
        return false
      }
    }
  },
  beforeMount() {
    // Check quote lifecycle (might be using back link or url)
    if (this.$store.state.agency.quotation.quoteLifeCycle !== 4) {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 4)
    }
    this.doInit()
  },
  mounted() {
    // Check if all busClsAppID falls inside the permitted list
    const selectedPlan = this.$store.getters.packageQuoteSelectedPlan
    let unsupported = []
    if (selectedPlan && selectedPlan.appIDs && selectedPlan.appIDs.length > 0) {
      for (const appID of selectedPlan.appIDs) {
        if (!supportedAppID.find(x => x === appID)) {
          unsupported.push(appID)
        }
      }
      if (unsupported.length > 0) {
        let unsupportedText = ''
        for (const temp of unsupported) {
          unsupportedText += temp + '/'
        }
        unsupportedText = unsupportedText.substring(0, unsupportedText.length - 1)
        this.errorMessage(`The following modules found in Risks are not supported. ${unsupportedText}`)
      }
    }
  },
  mixins: [
    MessageMixin,
    SaveQuoteMixin
  ]
}
</script>

<style>
</style>
